import React from 'react';
import './dropdown-menu.css';
import Popup, { IPopupProps } from '../popup/Popup';
import DropdownMenuCard, { IDropdownMenuCardProps } from './DropdownMenuCard';

interface IDropdownMenuPopupProps<Value> extends IDropdownMenuCardProps<Value> {
	popupOptions?: IPopupProps;
}

export default function DropdownMenuPopup<Value extends string = string>({
	options = [],
	popupOptions,
	...props
}: IDropdownMenuPopupProps<Value>) {
	return (
		// @ts-ignore
		<Popup
			anchorQuerySelector={popupOptions?.anchorQuerySelector}
			closeDelay={400}
			arrowClasses={['dropdown-menu-card-arrow']}
			{...popupOptions}
			placement={popupOptions?.placement || 'bottom'}
		>
			<DropdownMenuCard {...props} options={options} />
		</Popup>
	);
}
